/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCustomerHoldingsCurrentMarketValueRequest} from '@cash-web/protos/squareup/cash/portfolios/server/service.pb'
import {GetCustomerHoldingsCurrentMarketValueResponse} from '@cash-web/protos/squareup/cash/portfolios/server/service.pb'


export const getCustomerHoldingsCurrentMarketValue = (request: GetCustomerHoldingsCurrentMarketValueRequest, options?: CashRequestOptions) => post<GetCustomerHoldingsCurrentMarketValueRequest, GetCustomerHoldingsCurrentMarketValueResponse>("/2.0/cash/get-customer-holdings-current-market-value", request, {...options, rejectOnError: true })